import { createFileRoute } from "@tanstack/react-router";
import { Activities } from "@/components/Activities";

function RouteComponent() {
  return <Activities />;
}

export const Route = createFileRoute("/_authenticated/activities/")({
  component: RouteComponent,
  staticData: { page: "operations" },
});
